import PublicPostDetails from "../../../components/feed/PublicPostDetails";

const PublicPostPage = () => {
    return (
        <PublicPostDetails />
    )
} 

export default PublicPostPage;